import styled from 'styled-components';

import { Button, CloseIcon } from '@libs/components';

export const Line = styled.div`
  width: 100%;

  margin: 1.6rem 0;
  background-color: ${({ theme }) => theme.colors.borders.default};
  width: 100%;
  height: 0.1rem;
`;

export const Container = styled.div`
  padding: 7.1rem 2.2rem 3.6rem;
  max-width: 50rem;
  width: 100%;
  justify-self: center;

  ${({ theme }) => theme.media.tabletL`
    min-width:50rem;
    padding: 6.8rem 3.6rem 3.6rem;

  `}
`;

export const TimerWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.8rem;
`;

export const Block = styled.div`
  height: 4rem;
  width: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border: 0.1rem solid ${({ theme }) => theme.colors.interactive.brandColor};
  background-color: ${({ theme }) => theme.colors.surface.default};
`;

export const DiscalimerWrapper = styled.div`
  text-align: center;
  margin-bottom: 1.2rem;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  position: relative;
  align-items: center;
  text-align: center;
`;

export const CustomButton = styled(Button)`
  width: 100%;
  height: 6rem;
  margin-top: 2.4rem;
`;

export const CloseIconWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.surface.tertiary};

  width: 3.2rem;
  height: 3.2rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};
  cursor: pointer;
`;

export const CustomCloseIcon = styled(CloseIcon)`
  height: 1.2rem;
  width: 1.2rem; ;
`;

export const LottieWrapper = styled.div`
  width: 12.4rem;
  justify-self: center;
  margin-bottom: 2.5rem;
`;

export const WarningTitleTextWrapper = styled.div`
  margin-bottom: 1.2rem;
`;
